import { axiosInstance } from 'utils/AxiosInstance';
import { API_PATHS } from 'utils/constants';
import { IORGRegistrationRequest } from './../utils/contracts';

export const signupOrganization = async (
  signupData: IORGRegistrationRequest
) => {
  return await axiosInstance.post(API_PATHS.ORG_REGISTRATION, signupData);
};

export const GetUserOrganization = async (
  id: string,
  options?: { fresh?: boolean }
) => {
  try {
    const response = await axiosInstance.get(`${API_PATHS.GET_ORGANIZATION}${id}`, {
      headers: options?.fresh
        ? { 'Cache-Control': 'no-cache', Pragma: 'no-cache' }
        : {
            'Cache-Control': 'max-age=3600', // Cache for 1 hour
          },
      params: options?.fresh ? { _: Date.now() } : undefined,
    });
    
    // If the image is in the response, we can also cache it
    if (response.data?.image_url) {
      const cacheKey = `org-image-${id}`;
      localStorage.setItem(cacheKey, response.data.image_url);
    }
    
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const GetUserOrganizationShort = async (orgID: string): Promise<any> => {
  const {data} = await axiosInstance.get(API_PATHS.GET_ORGANIZATION + orgID + '/short');
  return data;
};

export const getVersion = async (): Promise<any> => {
  const { data: version } = await axiosInstance.post(API_PATHS.GET_VERSION);
  return version;
};

export const updateUserPresence = async () => {
  try {
    await axiosInstance.post('/user/presence');
    return true;
  } catch (error) {
    console.error('Error updating user presence:', error);
    return false;
  }
};
